import { render, staticRenderFns } from "./BlockSlider.vue?vue&type=template&id=a8a1caf4&"
import script from "./BlockSlider.vue?vue&type=script&lang=js&"
export * from "./BlockSlider.vue?vue&type=script&lang=js&"
import style0 from "./BlockSlider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports